import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import RadioFilter from './FilterComponents/CoreComponents/RadioFilter';

import styles from '../search.scss';

const PlayerTagsFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    const primaryTags = searchTypes && searchTypes.primaryTags ? searchTypes.primaryTags : [];

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'tags'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && filters.primaryTag) || filterModal === 'tags'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {
                    // eslint-disable-next-line no-nested-ternary
                    (filters && filters.primaryTag) ? (filters.primaryTag === 'HighSchool' ? 'High School' : filters.primaryTag) : 'Segment'
                }
            </Filter>
            {filterModal === 'tags' && (
                <FilterModal
                    title={'Segment'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <RadioFilter
                            name="primaryTag"
                            options={primaryTags}
                            selected={filterInputs.primaryTag}
                            onChange={(primaryTag) => {
                                handleFilterUpdate({ primaryTag });
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default PlayerTagsFilter;
